import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { buildGroupPathSegments } from "@common/helpers/accounting";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { GROUP_PATH_SEPARATOR } from "@components/forms/GroupSelectField/buildGroupPathSegments";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CoaMappingEllipsisText } from "./CoaMappingEllipsisText";
import { CoaMappingRow } from "../coaMappingRowTypes";
import styles from "../CoaMappingDrawer.module.scss";
import { useCoaMappingCellData } from "./useCoaMappingCellData";

export const CoaMappingGroupCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, CoaMappingRow, unknown>) => {
        const { kickAccount, options } = useCoaMappingCellData({
            row: row.original,
            table,
        });
        if (!kickAccount || !options) {
            return <ViewTableCell />;
        }
        return (
            <ViewTableCell className={styles.clippedCellHost}>
                <CoaMappingEllipsisText
                    text={buildGroupPathSegments(
                        options.kickGroups,
                        kickAccount.parentGroupId,
                    ).join(GROUP_PATH_SEPARATOR)}
                />
            </ViewTableCell>
        );
    },
);

CoaMappingGroupCell.displayName = "CoaMappingGroupCell";
